export default __webpack_public_path__ + "static/media/rent-house.a1140268.svg";